import { render } from "./NewMessageUploadEditor.vue?vue&type=template&id=38c73030&scoped=true"
import script from "./NewMessageUploadEditor.vue?vue&type=script&lang=js"
export * from "./NewMessageUploadEditor.vue?vue&type=script&lang=js"

import "./NewMessageUploadEditor.vue?vue&type=style&index=0&id=38c73030&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-38c73030"]])

export default __exports__